import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: {
        email: "",
        password: "",
        first_name: "",
        last_name: "",
        phone_number: "",
        country: "",
        travel_agency_uid: 0,
        travel_agency: "",
        abta: "",
        salesforce_agency_id: "",
        agency_phone_number: "",
        terms_conditions: "",
        confirm_password: "",
        travel_agency_logo: "", // it's used for STEWART TRAVEL LTD or STEWART TRAVEL,  possible values are "cruisekings_logo.png" or "stewart_travel_logo.png" or "scotland_cruise_centre_logo.png"
    },
    loading: false,
    valid: false,
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(incrementAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.
export const incrementAsync = createAsyncThunk("register/fetchCount", async (amount) => {
    // The value we return becomes the `fulfilled` action payload
});

export const registerSlice = createSlice({
    name: "register",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        addToRegister: (state, action) => {
            state.data = action.payload;
        },
        addToRegisterValid: (state, action) => {
            state.valid = action.payload;
        },
        addToRegisterLoading: (state, action) => {
            state.loading = action.payload;
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: (builder) => {},
});

export const { addToRegister, addToRegisterValid, addToRegisterLoading } = registerSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.register.value)`
export const selectRegister = (state) => state.register;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const clearRegisterData = () => (dispatch, getState) => {
    dispatch(
        addToRegister({
            email: "",
            password: "",
            first_name: "",
            last_name: "",
            phone_number: "",
            country: "UK",
            travel_agency_uid: 0,
            travel_agency: "",
            abta: "",
            salesforce_agency_id: "",
            agency_phone_number: "",
            terms_conditions: "",
            confirm_password: "",
        })
    );
};

export default registerSlice.reducer;
